"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _typography = require("../../typography");

var _theme = require("../../theme");

var Textarea =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Textarea, _PureComponent);

  function Textarea() {
    (0, _classCallCheck2.default)(this, Textarea);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Textarea).apply(this, arguments));
  }

  (0, _createClass2.default)(Textarea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          className = _this$props.className,
          css = _this$props.css,
          width = _this$props.width,
          height = _this$props.height,
          disabled = _this$props.disabled,
          required = _this$props.required,
          isInvalid = _this$props.isInvalid,
          appearance = _this$props.appearance,
          placeholder = _this$props.placeholder,
          spellCheck = _this$props.spellCheck,
          grammarly = _this$props.grammarly,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["theme", "className", "css", "width", "height", "disabled", "required", "isInvalid", "appearance", "placeholder", "spellCheck", "grammarly"]);
      var themedClassName = theme.getTextareaClassName(appearance);
      return _react.default.createElement(_typography.Text, (0, _extends2.default)({
        is: "textarea",
        className: (0, _classnames.default)(themedClassName, className),
        size: 400,
        width: width,
        height: height,
        required: required,
        disabled: disabled,
        placeholder: placeholder,
        paddingLeft: Math.round(height / 3.2),
        paddingRight: Math.round(height / 3.2),
        borderRadius: 3,
        spellCheck: spellCheck,
        "aria-invalid": isInvalid,
        "data-gramm_editor": grammarly
      }, disabled ? {
        color: 'muted'
      } : {}, {
        css: css
      }, Textarea.styles, props));
    }
  }]);
  return Textarea;
}(_react.PureComponent);

Textarea.displayName = "Textarea";
(0, _defineProperty2.default)(Textarea, "propTypes", (0, _objectSpread2.default)({}, _typography.Text.propTypes, {
  /**
   * Makes the textarea element required.
   */
  required: _propTypes.default.bool,

  /**
   * Makes the textarea element disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * Sets visual styling of _only_ the text area to be "invalid". 
   * Note that this does not effect any `validationMessage`.
   */
  isInvalid: _propTypes.default.bool,

  /**
   * Use the native spell check functionality of the browser.
   */
  spellCheck: _propTypes.default.bool,

  /**
   * Allow the Grammarly browser extension to attach to the backing textarea.
   */
  grammarly: _propTypes.default.bool,

  /**
   * The placeholder text when there is no value present.
   */
  placeholder: _propTypes.default.string,

  /**
   * The appearance of the TextInput.
   */
  appearance: _propTypes.default.string,

  /**
   * The width of the TextInput.
   */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Theme provided by ThemeProvider.
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Class name passed to the button.
   * Only use if you know what you are doing.
   */
  className: _propTypes.default.string
}));
(0, _defineProperty2.default)(Textarea, "defaultProps", {
  appearance: 'default',
  width: '100%',
  disabled: false,
  isInvalid: false,
  spellCheck: true,
  grammarly: false
});
(0, _defineProperty2.default)(Textarea, "styles", {
  minHeight: 80,
  paddingX: 10,
  paddingY: 8
});

var _default = (0, _theme.withTheme)(Textarea);

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/textarea/src/Textarea.js
// module id = 216
// module chunks = 0